import { AccountType, AccountTypeUrls } from 'utils/constants';
import config from './config';

export const appendBasePath = (relativeRoute: string) => {
  const basePath = config.basePath;
  return `${basePath}${relativeRoute}`;
};

export const handleOpenNewAccount = (
  nasuLink: string | null,
  accountTypeId: number | null,
) => {
  const accountTypeUrl = accountTypeId
    ? AccountTypeUrls[accountTypeId as AccountType]
    : null;

  if (accountTypeUrl) {
    window.location.assign(`${config.url}${accountTypeUrl}`);
  } else if (nasuLink) {
    window.location.assign(nasuLink);
  }
};

export function isMocks() {
  return import.meta.env.VITE_MOCK;
}

export function isLocalhost() {
  return window && window.location.hostname.toLowerCase().indexOf('localhost') !== -1;
}
